import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import TeamImg from "../../../assets/images/png/hero-hiring-team-v2.webp";
import Avatar1 from "../../../assets/images/png/talent-leader.webp";
import Avatar2 from "../../../assets/images/png/avatars/2.webp";
import Avatar3 from "../../../assets/images/png/avatars/3.webp";

import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";

const shortlist = [
  { img: Avatar1, name: "Amara O.", role: "Senior Data Engineer", match: 98 },
  { img: Avatar2, name: "Tobi A.", role: "Product Manager", match: 95 },
  { img: Avatar3, name: "Wanjiku N.", role: "AI / ML Engineer", match: 92 },
];

const HireHeaderSection = () => {
  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      id="top"
      style={{
        backgroundImage:
          "radial-gradient(circle at 92% 8%, rgba(251,175,27,0.16), transparent 25%), linear-gradient(#fff 0%, #f7f9ff 100%)",
      }}
    >
      <HeaderNavigation />

      <div className="container mx-auto px-4 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 lg:gap-10">
          <div className="w-full">
            <Animate.Fade bottom>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Build a global team in days
              </p>

              <h1 className="text-5xl md:text-6xl lg:text-[68px] font-poppins tracking-[-0.03em] leading-[1.02] font-black mb-7">
                <span className="text-default">We Developed the Talent.</span>{" "}
                <span className="text-primary block">Now Build Your Team.</span>
              </h1>

              <p className="font-poppins text-lg md:text-xl text-gray leading-relaxed mb-9 max-w-xl">
                Utiva gives companies access to developed, assessed and
                work-ready professionals—and the infrastructure to hire,
                onboard, manage and pay them globally.
              </p>

              <div className="flex flex-wrap font-poppins items-center gap-5 md:gap-7 text-base md:text-lg mb-10">
                <a
                  href="https://app.utiva.co/signup?goal=employer"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-secondary bg-primary font-poppins custom-btn px-8 py-4 text-center rounded-xl inline-flex items-center font-bold shadow-course-feature focus:outline-none"
                >
                  Hire Talent
                  <span className="ml-2">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </a>
                <a
                  href="#talent-network"
                  className="text-primary text-base font-poppins font-bold underline decoration-secondary decoration-2 underline-offset-4 hover:opacity-80 transition-all"
                >
                  Explore the Talent Network ↓
                </a>
              </div>

              <div className="flex flex-wrap items-center gap-3 pt-6 border-t border-hire-line text-gray text-sm font-poppins">
                <strong className="text-primary font-extrabold">
                  20,000+ talent
                </strong>
                <span className="text-secondary">•</span>
                <strong className="text-primary font-extrabold">
                  150+ companies
                </strong>
                <span className="text-secondary">•</span>
                <strong className="text-primary font-extrabold">
                  Hire in as little as 1 week
                </strong>
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full">
            <Animate.Fade bottom>
              <div
                className="relative rounded-3xl overflow-hidden shadow-course-feature-lg"
                style={{ minHeight: "560px" }}
              >
                <img
                  src={TeamImg}
                  alt="Hiring leaders reviewing shortlisted global talent"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: "55%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,71,0.88))",
                  }}
                ></div>

                <div className="absolute top-5 right-5 z-10 w-11/12 sm:w-72 bg-white/95 backdrop-blur rounded-2xl p-4 shadow-course-feature">
                  <div className="flex justify-between items-center gap-3 mb-2.5 pb-2.5 border-b border-hire-line">
                    <span className="text-primary tracking-widest text-xs font-extrabold">
                      SHORTLIST READY
                    </span>
                    <b className="text-utiva-green bg-green-50 rounded-full px-2.5 py-1 text-xs">
                      12 matched
                    </b>
                  </div>
                  {shortlist.map((person) => (
                    <div
                      key={person.name}
                      className="grid grid-cols-hire-list-46 items-center gap-2.5 py-2 border-b border-hire-line last:border-0"
                      style={{ gridTemplateColumns: "40px 1fr auto" }}
                    >
                      <img
                        src={person.img}
                        alt=""
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <p className="m-0 grid gap-0.5">
                        <strong className="text-default text-sm">
                          {person.name}
                        </strong>
                        <small className="text-gray text-xs">
                          {person.role}
                        </small>
                      </p>
                      <span className="text-utiva-green text-xs font-extrabold">
                        {person.match}% match
                      </span>
                    </div>
                  ))}
                </div>

                <div className="absolute z-10 bottom-24 left-5 bg-secondary text-primary rounded-2xl px-4 py-3 shadow-course-feature grid">
                  <strong className="text-2xl leading-none">1 week</strong>
                  <span className="text-xs font-bold mt-1">
                    to your next great hire
                  </span>
                </div>

                <div className="absolute z-10 bottom-5 left-5 right-5 bg-primary backdrop-blur text-white rounded-2xl flex items-center justify-between gap-3 px-4 py-3.5">
                  <span className="text-xs font-extrabold tracking-wide">
                    01 SHORTLIST
                  </span>
                  <b className="text-secondary">→</b>
                  <span className="text-xs font-extrabold tracking-wide">
                    02 INTERVIEW
                  </span>
                  <b className="text-secondary">→</b>
                  <strong className="text-secondary text-xs font-extrabold tracking-wide">
                    03 HIRE
                  </strong>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HireHeaderSection;
